<main class="c-main wow-consulta">

  <div class="container-fluid">

    <div class="mat-elevation-z8">

      <mat-card>

        <div class="wow-consulta__header">

          <div class="wow-consulta__header-icon"><mat-icon>account_balance</mat-icon></div>

          <mat-card-title>Contas Correntes</mat-card-title>

        </div>



        <app-wow-consulta-filtros

          [tipoFiltros]="tipoFiltros"

          [(tipoFiltro)]="tipoFiltro"

          [(parametro)]="parametro"

          [parametroMask]="tipoFiltro === 'ID' ? 'separator.0' : ''"

          [showSituacao]="true"

          [(situacao)]="situacao"

          (tipoFiltroChange)="onFiltroChange()"

          (consultar)="consultar()"

          (novo)="novo()">

        </app-wow-consulta-filtros>



        <div class="wow-consulta__empty" *ngIf="!consultaRealizada">

          Informe os filtros (opcional) e clique em <strong>Consultar</strong>.

        </div>



        <table *ngIf="consultaRealizada" mat-table [dataSource]="contas" class="full-width cc-tabela">

          <ng-container matColumnDef="id">

            <th mat-header-cell *matHeaderCellDef>ID</th>

            <td mat-cell *matCellDef="let c">{{ c.id }}</td>

          </ng-container>

          <ng-container matColumnDef="descricao">

            <th mat-header-cell *matHeaderCellDef>Nome</th>

            <td mat-cell *matCellDef="let c">{{ c.descricao }}</td>

          </ng-container>

          <ng-container matColumnDef="banco">

            <th mat-header-cell *matHeaderCellDef>Banco</th>

            <td mat-cell *matCellDef="let c">{{ labelBanco(c.banco) }}</td>

          </ng-container>

          <ng-container matColumnDef="agencia">

            <th mat-header-cell *matHeaderCellDef>Agência / Conta</th>

            <td mat-cell *matCellDef="let c">

              {{ c.agencia || '—' }} / {{ c.numeroConta || '—' }}{{ c.digitoConta ? '-' + c.digitoConta : '' }}

            </td>

          </ng-container>

          <ng-container matColumnDef="ativa">

            <th mat-header-cell *matHeaderCellDef>Situação</th>

            <td mat-cell *matCellDef="let c">{{ c.ativa !== false ? 'Ativa' : 'Inativa' }}</td>

          </ng-container>

          <ng-container matColumnDef="acoes">

            <th mat-header-cell *matHeaderCellDef></th>

            <td mat-cell *matCellDef="let c" (click)="$event.stopPropagation()">

              <button mat-icon-button color="accent" matTooltip="Alterar" (click)="editar(c)">

                <mat-icon>edit</mat-icon>

              </button>

              <button mat-icon-button color="warn" matTooltip="Inativar" (click)="excluir(c)">

                <mat-icon>delete</mat-icon>

              </button>

            </td>

          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['id','descricao','banco','agencia','ativa','acoes']"></tr>

          <tr mat-row *matRowDef="let row; columns: ['id','descricao','banco','agencia','ativa','acoes'];"
            class="wow-consulta__row" (click)="editar(row)"></tr>

        </table>

      </mat-card>

    </div>

  </div>

</main>

